import React from 'react'
import { TestIds } from '../testIds'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import { URLS } from '../util/consts'
import {
  useHasShareholderAccounts,
  useIsShareholder,
} from '../features/azure-b2c/components/MsalRouter'
import { useSelector } from 'react-redux'
import { selectCurrentFarmerAccount } from '../features/azure-b2c/storage'

export function NoAccess() {
  const isShareholder = useIsShareholder()
  const currentAccount = useSelector(selectCurrentFarmerAccount)
  const hasShareholder = useHasShareholderAccounts()

  const openFindOutMore = () => {
    window.open(URLS.findOutMore, '_blank')
  }

  const openSignUpNow = () => {
    window.open(URLS.signUpNow, '_blank')
  }

  const switchBackView = () => {
    return (
      <PageContainer data-testid={TestIds.pages.mixedAccessShareholderAccess}>
        <YesNoAction
          display='Kia Ora,'
          subheading='Welcome to FarmlandsPRO'
          body={
            <span>
              <span>Account: {currentAccount?.accountName}</span>
              <br />
              <span>Account number: {currentAccount?.accountNumber}</span>
              <br />
              <br />
              This account is not a Farmlands shareholder account. If you have other accounts with
              Farmlands you can switch using the account selector.
              <br />
              <br />
              If you’d like to find out more information or sign up to become a shareholder, please
              following the links below.
            </span>
          }
          optionA={{
            label: 'Find out more',
            onClick: openFindOutMore,
          }}
          optionB={{
            label: 'Sign up now',
            onClick: openSignUpNow,
          }}
        />
      </PageContainer>
    )
  }

  const defaultView = () => {
    return (
      <PageContainer data-testid={TestIds.pages.noShareHolderAccess}>
        <YesNoAction
          display='Kia Ora,'
          subheading='Welcome to FarmlandsPRO'
          body='FarmlandsPRO is a platform for Farmlands shareholders. If you’d like to find out more information or sign up to become a shareholder, please follow the links below.'
          optionA={{
            label: 'Find out more',
            onClick: openFindOutMore,
          }}
          optionB={{
            label: 'Sign up now',
            onClick: openSignUpNow,
          }}
        />
      </PageContainer>
    )
  }

  const getView = React.useMemo(() => {
    if (hasShareholder) {
      return switchBackView()
    } else {
      return defaultView()
    }
  }, [hasShareholder, isShareholder])

  return getView
}
export default NoAccess
